import { render, staticRenderFns } from "./created-coupon.vue?vue&type=template&id=e96059c6&scoped=true&"
import script from "./created-coupon.vue?vue&type=script&lang=ts&"
export * from "./created-coupon.vue?vue&type=script&lang=ts&"
import style0 from "./created-coupon.vue?vue&type=style&index=0&id=e96059c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96059c6",
  null
  
)

export default component.exports